(() => {
  const SEL = '.js-product-countdown[data-end-date]';
  const visible = new Set();
  const ends = new WeakMap();

  function pad2(n) {
    n = Math.max(0, n);
    return n < 10 ? '0' + n : String(n);
  }

  function parseEnd(el) {
    const endAttr = el.getAttribute('data-end-date');
    if (!endAttr) return null;

    const t = Date.parse(endAttr);
    if (!Number.isFinite(t)) return null;

    return t;
  }

  function getParts(el) {
    return {
      daysEl: el.querySelector('.js-cd-days'),
      hoursEl: el.querySelector('.js-cd-hours'),
      minutesEl: el.querySelector('.js-cd-minutes'),
      secondsEl: el.querySelector('.js-cd-seconds'),
      labelEl: el.querySelector('.product-card-countdown__label')
    };
  }

  function hideCountdown(el) {
    el.classList.add('is-expired');
    el.hidden = true; // ✅ вместо 00:00:00 → скрива таймера
    visible.delete(el);
    try { io.unobserve(el); } catch (e) {}
  }

  function updateOne(el, nowMs) {
    if (el.hidden) {
      visible.delete(el);
      return;
    }

    let endMs = ends.get(el);
    if (!endMs) {
      endMs = parseEnd(el);
      if (!endMs) {
        hideCountdown(el);
        return;
      }
      ends.set(el, endMs);
    }

    const parts = getParts(el);
    if (!parts.daysEl || !parts.hoursEl || !parts.minutesEl || !parts.secondsEl) {
      hideCountdown(el);
      return;
    }

    const diff = endMs - nowMs;
    if (diff <= 0) {
      hideCountdown(el);
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const d = pad2(days);
    const h = pad2(hours);
    const m = pad2(minutes);
    const s = pad2(seconds);

    if (parts.labelEl) parts.labelEl.textContent = 'Офертата изтича след';

    if (parts.daysEl.textContent !== d) parts.daysEl.textContent = d;
    if (parts.hoursEl.textContent !== h) parts.hoursEl.textContent = h;
    if (parts.minutesEl.textContent !== m) parts.minutesEl.textContent = m;
    if (parts.secondsEl.textContent !== s) parts.secondsEl.textContent = s;
  }

  function tick() {
    if (!visible.size) return;
    const nowMs = Date.now();
    visible.forEach((el) => updateOne(el, nowMs));
  }

  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting && !e.target.hidden) visible.add(e.target);
      else visible.delete(e.target);
    }
    tick();
  }, { rootMargin: '200px 0px' });

  function init(scope = document) {
    if (!scope || !scope.querySelectorAll) return;

    const nodes = scope.querySelectorAll(SEL);
    if (!nodes.length) return;

    const now = Date.now();

    nodes.forEach((el) => {
      if (el.dataset.cardCountdownInit === '1') return;
      el.dataset.cardCountdownInit = '1';

      const endMs = parseEnd(el);
      if (!endMs) {
        hideCountdown(el);
        return;
      }

      ends.set(el, endMs);

      if (endMs <= now) {
        hideCountdown(el);
        return;
      }

      // ✅ КРИТИЧНО: на PDP понякога IO callback не идва веднага.
      // Добавяме елемента директно в visible и тикваме.
      if (!el.hidden) visible.add(el);

      io.observe(el);
    });

    tick();
  }

  // ✅ ЕКСПОРТ за AJAX (препоръки, infinite scroll, филтри и т.н.)
  // Викай: window.initCardCountdowns(containerElement)
  window.initCardCountdowns = function (scope) {
    init(scope || document);
  };

  // 1 интервал за всички
  setInterval(tick, 1000);

  // initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Shopify section reloads
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));

  // fallback за инжектиране без section events
  let moTimer = null;
  const mo = new MutationObserver((mutations) => {
    if (moTimer) return;
    moTimer = setTimeout(() => {
      moTimer = null;
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          init(document);
          break;
        }
      }
    }, 200);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
